import { render, staticRenderFns } from "./GroupAdmin.vue?vue&type=template&id=eee95906&scoped=true"
import script from "./GroupAdmin.vue?vue&type=script&lang=js"
export * from "./GroupAdmin.vue?vue&type=script&lang=js"
import style0 from "./GroupAdmin.vue?vue&type=style&index=0&id=eee95906&prod&lang=scss"
import style1 from "./GroupAdmin.vue?vue&type=style&index=1&id=eee95906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee95906",
  null
  
)

export default component.exports